import { TimelinePayload } from '~/common/types/types';

const timelinePayload: TimelinePayload = {
  badgeText: 'timeline.badge',
  sections: [
    {
      title: 'timeline.section0.title',
      subtitle: 'timeline.section0.subtitle',
      descriptor: {
        text: 'timeline.section0.descriptor',
        position: 'right',
      },
      items: [
        {
          title: 'timeline.section0.group0.title',
          description: 'timeline.section0.group0.description',
          dateStart: '2026-03-11',
          dateEnd: '2026-05-15',
          dateSeparator: null,
        },
        {
          title: 'timeline.section0.group1.title',
          description: 'timeline.section0.group1.description',
          dateStart: '2026-05-16',
          dateEnd: '2026-05-19',
          dateSeparator: 'timeline.section0.group1.dateSeparator',
        },
        {
          title: 'timeline.section0.group2.title',
          description: 'timeline.section0.group2.description',
          dateStart: '2026-05-22',
          dateEnd: '2026-06-02',
          dateSeparator: null,
        },
      ],
    },
    {
      title: 'timeline.section1.title',
      subtitle: 'timeline.section1.subtitle',
      descriptor: {
        text: 'timeline.section1.descriptor',
        position: 'left',
      },
      sectionHighlight: 'secondary',
      items: [
        {
          title: 'timeline.section1.group0.title',
          description: 'timeline.section1.group0.description',
          dateStart: '2026-06-17',
          dateEnd: '2026-08-13',
          dateSeparator: null,
        },
        {
          title: 'timeline.section1.group1.title',
          description: 'timeline.section1.group1.description',
          dateStart: '2026-06-17',
          dateEnd: '2026-08-13',
          dateSeparator: null,
        },
        {
          title: 'timeline.section1.group2.title',
          description: 'timeline.section1.group2.description',
          dateStart: '2026-08-21',
          dateEnd: '2026-10-02',
          dateSeparator: null,
        },
        {
          title: 'timeline.section1.group3.title',
          description: 'timeline.section1.group3.description',
          dateStart: '2026-10-03',
          dateEnd: null,
          dateSeparator: null,
        },
      ],
    },
  ],
};

export { timelinePayload };
